module.exports = __webpack_public_path__ + "img/beer_id-77.e7f9927d.png";